import React from 'react';

export const ErrorPago = ({data1, errore}) => {
    const {mdn} = data1;
    const {code,description} = errore;
    return (
        <>
      <div className='contenedorTicket'>
          <div className='parte1'>
              <div className='iconoError'></div>
              <div className='tituloTicket'>Error o rechazo en el pago</div>
              
              <p>Hubo algún problema o rechazaste el pago, intenta de nuevo más tarde u otra forma de pago</p>
              <p>Código: {code}, {description}</p>
          </div>
          <div className='parte2'>
              <div className='contNum'>
                  <span className='icoCel'></span>
                  <span className='textoIco'>{mdn}</span>
              </div>
          </div>
      </div>
     
    
      </>
    )
}
